const requiredMsg = 'Pole jest wymagane...';
const emailMsg = 'Nieprawidłowy adres e-mail';
const nipMsg = 'Nieprawidłowy numer NIP';

export {
    requiredMsg,
    emailMsg,
    nipMsg
};